"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var horizontalScroll = function horizontalScroll(scrolledEl) {
  var tag = scrolledEl.tagName === 'MAIN' ? 'header' : 'main';
  var el = scrolledEl.parentElement.querySelectorAll(tag);

  if (el) {
    el.forEach(function (element) {
      element.scrollLeft = scrolledEl.scrollLeft;
    });
  }
};

var _default = horizontalScroll;
exports.default = _default;